<template>
  <div class="home_container" :class="[isNewSkin ? 'home_container_bg_new' : 'home_container_bg']" ref="home_container">
    <div class="header_container">
      <div class="logo">
        <img src="../assets/image/logo.png" alt />
      </div>
      <div class="centerBtn"></div>
      <div class="rightBtn" v-if="backFlag">
        <div class="myGiftBtn" @click="$router.go(-1)">
          <!-- 旧按钮路径 -->
          <img v-if="!isNewSkin" src="../assets/image/button/backBtn.png" alt />
          <!-- 新按钮路径 -->
          <img v-else src="../assets/image/gameImages/button/backBtn.png" alt />
        </div>
      </div>
      <div class="rightIcon"></div>
    </div>
    <div class="ruleTitle">
      <van-row class="m_b">
        <van-col span="24" class="c_w m_b5 t_ac f_25">我的奖品</van-col>
      </van-row>
      <van-row class="m_b"> </van-row>
      <van-row class="m_b5">
        <van-col span="24" class="c_w m_b5 t_ac f_20">
          <!-- <div class="onlyLine">
            <img src="../assets/image/onlyLine.png" alt />
          </div> -->
          <div class="onlyLine02">
            <img src="../assets/image/onlyLine.png" alt />
          </div>
        </van-col>
      </van-row>
      <van-row class="m_b5" style="padding: 0px 20px;">
        <van-col span="24" class="c_w m_b5 f_12">☆【已加入卡包】表示奖券已自动放入【我的卡包】中，请点击按钮【点击查看】到【我的卡包】查看即可；</van-col>
      </van-row>
      <!-- <van-row class="m_b5" style="padding: 0px 20px;">
        <van-col span="24" class="c_w m_b5 f_12">☆【未加入卡包】表示奖券还未放入【我的卡包】中，请点击按钮【加入卡包】后，到【我的卡包】查看即可；</van-col>
      </van-row> -->
      <van-row class="m_b5" style="padding: 0px 20px;">
        <van-col span="24" class="c_w m_b5 f_12">☆【已填写信息】表示已填写个人详细地址信息，请点击按钮【点击查看】查看您的详细地址信息；</van-col>
      </van-row>
      <van-row class="m_b5" style="padding: 0px 20px;">
        <van-col span="24" class="c_w m_b5 f_12">☆【未填写信息】表示还未填写个人详细地址信息，请点击按钮【立即填写】进行编辑即可。</van-col>
      </van-row>
      <van-row class="m_b5" style="padding: 0px 20px;">
        <van-col span="24" class="c_w m_b5 f_12">☆ 若领券手机号与绑定微信手机号及达美乐官网（含PC/手机端官网、微信、官方APP）订餐手机号一致，则可 点击【我的卡包】即可查看券详情。</van-col>
      </van-row>
      <van-row class="m_b35" style="padding: 0px 20px;">
        <van-col span="24" class="c_w f_12"
        >☆ 若领券手机号与绑定微信手机号及达美乐官网（含PC/手机端官网、微信、官方APP）订餐手机号不一致，或没有在官网登陆过，则需点击【我的卡包】输入手机号后，【立即开卡】，即可查看券详情。</van-col
        >
      </van-row>
      <van-row class="m_b5" id="bag-box">
        <van-col span="24" class="c_w m_b5">
          <!--type 类型 0:优惠卷 1:实体 -->
          <!-- fillIn 类型为0 是否加入卡包 类型为1 是否填写收货地址 -->
          <div class="allOfOne" :class="[isNewSkin ? 'allOfOne_bg_new' : 'allOfOne_bg']" v-for="(item, i) in myGifttAll" :key="i" v-show="loadingFlag === '0' || myGifttAll.length">
            <div class="leftTopImg">
              <!-- 已填写信息： -->
              <!-- 兼容新旧图片路径 -->
              <img v-if="item.type === 1 && item.fillIn === true" :src="isNewSkin ? require('../assets/image/gameImages/yitianxie Info.png') : require('../assets/image/yitianxie Info.png')" alt />
              <!-- 未填写信息： -->
              <img v-else-if="item.type === 1 && item.fillIn === false" :src="isNewSkin ? require('../assets/image/gameImages/noInfo.png') : require('../assets/image/noInfo.png')" alt />
              <!-- 已加入卡包： -->
              <img v-else-if="item.type === 0 && item.fillIn === true" :src="isNewSkin ? require('../assets/image/gameImages/addCard.png') : require('../assets/image/addCard.png')" alt />
              <!-- 未加入卡包： -->
              <img v-else-if="item.type === 0 && item.fillIn === false" :src="isNewSkin ? require('../assets/image/gameImages/noAddCard.png') : require('../assets/image/noAddCard.png')" alt />
            </div>
            <div class="content_containerBox">
              <div class="leftImgShow">
                <img :src="item.imgUrl" />
              </div>
              <div class="rightBtnTitle t_ac">
                <div class="giftName_Box">
                  {{ item.giftName }}
                </div>
                <!-- 20210607 add start: -->
                <div class="gift_name_bottom_time_box">抽奖时间：{{ item.createTime.includes(' ') && item.createTime.split(' ')[0] }}</div>
                <!-- 20210607 add end -->
                <div class="btn">
                  <!-- 点击查看： -->
                  <img v-if="(item.type === 1 && item.fillIn === true) || (item.type === 0 && item.fillIn === true)" :src="isNewSkin ? require('../assets/image/gameImages/button/clickOpen.png') : require('../assets/image/button/clickOpen.png')" @click="goLook(item)" />
                  <!-- 加入卡包： -->
                  <img v-else-if="item.type === 0 && item.fillIn === false" :src="isNewSkin ? require('../assets/image/gameImages/button/addCardNow.png') : require('../assets/image/button/addCardNow.png')" @click="toAddCard(item.callbackUuid)" />
                  <!-- 填写信息： -->
                  <div v-else-if="item.type === 1 && item.fillIn === false">
                    <img v-if="item.isRed == 1" :src="isNewSkin ? require('../assets/image/gameImages/button/writeNow.png') : require('../assets/image/button/writeNow.png')" @click="toWritePage(item)" />
                    <!-- 灰色背景 -->
                    <div v-else-if="item.isRed == 0" style="background-color: #cccccc; color: #A8A8A8" @click="toToast(item)">立即填写</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 20210607 add start: -->
            <!-- 订单号： -->
            <div class="order_id_container">订单号：{{ item.orderId ? item.orderId : '- -' }}</div>
            <!-- 20210607 add end -->
          </div>
          <div class="loadingBox" v-show="loadingFlag === '1'">
            <div class="content_loadingBox">
              <img :src="require(`../assets/image/rider.gif`)" alt="" />
            </div>
          </div>
          <div class="allNull" v-show="loadingFlag === '2'">
            <div class="content_loadingBox">
              <img src="../assets/image/riderTip.24cbcc1b.png" alt="" />
              <p>暂无数据哦！</p>
            </div>
          </div>
          <div class="searchMore" v-show="moreFlag" @click="getMoreData">查看更多>></div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { Dialog } from 'vant';
import URL from '@/utils/url';
import loadJs from "@/utils/weChatUniapp";

export default {
	data() {
		return {
			myGifttAll: [],
			isAddFlag: false,
			loadingFlag: '1',
            moreFlag: false, // 是否显示更多按钮
            pageSize: 10,
            pageNum: 1,
      backFlag: true,
      isNewSkin: false, // 是否新皮肤
		};
	},
	computed: {
		userInfo02: function() {
			return this.$store.getters.getInfo02;
		},
	},
	methods: {
		async getAllGift() {
			if (!this.userInfo02) {
				return Toast('抱歉，用户信息错误，无法获取记录');
			}
			this.loadingFlag = '1';
			let params = {
				luckActId: this.userInfo02.luckActId,
				param: this.userInfo02.param,
                pageNum: this.pageNum,
                pageSize: this.pageSize
			};
			try {
				let { data: result } = await this.$get('findLucyRecord', params);
				if (result.code !== 200) {
					return Toast(result.errMsg);
				}
                if (this.pageNum > 1) {
                    let add = JSON.parse(JSON.stringify(result.data.records));
                    this.myGifttAll = this.myGifttAll.concat(add)
                } else {
                    this.myGifttAll = result.data.records;
                }

                if (result.data.records && result.data.records.length >= this.pageSize) {
                    this.moreFlag = true
                } else {
                    this.moreFlag = false
                }
				if (this.myGifttAll.length) {
					this.loadingFlag = '0';
				} else {
					this.loadingFlag = '2';
				}
                this.$nextTick(() => {
                  if (this.myGifttAll && this.myGifttAll.length != 0) {
                    const el = document.querySelector('#bag-box');
                    const parent = document.querySelector('.home_container');
                    if (this.pageNum == 1) {
                        parent.scrollTop = el.offsetTop - parent.offsetTop;
                    }
                  }
                })
			} catch (err) {
				console.log(err);
			}
		},
		// 获取用户信息：
		async getUserInfo() {
			if (!this.userInfo02) {
				return Toast('抱歉，用户信息错误，无法获取记录');
			}
			let params = {
				luckActId: this.userInfo02.luckActId,
				param: this.userInfo02.param,
			};
			try {
				let { data: result } = await this.$get('getInformationByParam', params);
				if (result.code !== 200) {
					this.$store.commit('LOGOUT');
					this.$store.commit('LOGOUT02');
					if (result.code === 500 && result.errMsg === '没有可以参加的活动,或活动已过期') {
						this.pastDue = result.errMsg;
						return this.$router.push({ name: 'noActive' });
						// return Toast(result.errMsg);
					} else {
						return Toast('抱歉，不满足抽奖资格');
					}
				}
				this.$store.commit('LONIN_SET', result.data);
				// 2020 09 30 zzg add start 新增逻辑:
				if (result.data.luckActId && result.data.encryption) {
					let baseUrlObj = {
						luckActId: result.data.luckActId,
						param: result.data.encryption,
					};
					// 设置用户参数：
					this.$store.commit('LONIN_SET02', baseUrlObj);
				}
				// 2020 09 30 zzg add end
			} catch (err) {
				console.log(err);
			}
		},
		// 点击查看：
		goLook(item) {
			this.$Sensors.track('LuckydrawMygiftPageClick', {
				button_name: '点击查看',
			});


            // type 类型 0:优惠卷 1:实体
            if (item.type === 1) {
                let query = {
                    uid: item.callbackUuid,
                    orderNo: item.orderId,
                    check: true,
                    name: item.name,
                    shengshiqu: item.shengshiqu,
                    addressDetail: item.detailAddress,
                    phoneNumber: item.consigneePhoneNumber,
                    isRed: item.isRed
                }
                this.$router.push({ name: 'address', query: query });
            } else {
                top.window.location.href = this.$linkURL + 'my/coupon/list'; //pro
            }
		},
		// 加入卡包：
		async toAddCard(val) {
			if (this.isAddFlag) {
				return;
			}
			this.isAddFlag = true;
			const toastLoading = Toast.loading({
				message: '正在加入卡包',
				forbidClick: true,
				duration: 0,
			});
			try {
				let { data: result } = await this.$post(`/consumer/mkt-activity/addCoupon?callbackUUId=${val}`);
				if (result.code !== 200) {
					this.isAddFlag = false;
					return Toast(result.errMsg);
				}
				this.isAddFlag = false;
				toastLoading.clear();
				Toast('加入卡包成功');
				this.getAllGift();
			} catch (err) {
				console.log(err);
			}
		},
		// 填写信息：
		toWritePage(item) {
      this.toToast(item)
			// this.$router.push({ name: 'address', query: { uid: item.callbackUuid, orderNo: item.orderId} });
		},
        // 填写信息: -- 灰色背景--toast提示
        async toToast(item) {
          try {
            let params = {
              orderNo: item.orderId,
            };
            let { data: result } = await this.$get('checkWriteAddress', params);
            if (result.code !== 200) {
              //   return Toast(result.errMsg);
              Dialog.alert({
                message: result.errMsg,
                confirmButtonText: "我知道了"
              }).then(() => {
                // on close
              });
              return
            } else {
              // 填写信息：
              this.$router.push({ name: 'address', query: { uid: item.callbackUuid, orderNo: item.orderId} });
            }
          } catch (err) {
            console.log(err);
          }
        },
        // 查看更多
        getMoreData() {
            this.pageNum ++
            this.getAllGift();
        }
	},
	created() {
		if (window.location.href.includes('luckActId') && window.location.href.includes('param')) {
			// 通过地址栏拿到信息：
			this.$store.commit('LOGOUT');
			this.$store.commit('LOGOUT02');
			let $url = URL;
			let baseUrlStr = window.location.href;
			const baseUrlObj = $url.toObject(baseUrlStr, true);
			this.$store.commit('LONIN_SET02', baseUrlObj);
		}

    this.isNewSkin = sessionStorage.getItem('isNewSkin') ? true : false;
	},
	mounted() {
		if (window.location.href.includes('luckActId') && window.location.href.includes('param')) {
			setTimeout(() => {
				this.getUserInfo();
			}, 300);
		}
		setTimeout(() => {
			this.getAllGift();
		}, 600);
        // 给dom盒子加滚动事件
        // this.$refs.home_container.onscroll = () => {
        //     this.scrollTop = this.$refs.home_container.scrollTop;
        //     console.log('--2---this.scrollTop=', this.scrollTop)
        //     localStorage.setItem("scrollTop", this.scrollTop)
        //     // localStorage.getItem("key名") - 把叫key的对应值, 从浏览器本地取出来
        // }

        const userAgent = navigator.userAgent;
        // 是否微信环境
        const isWechat = userAgent.match(/MicroMessenger|wechat/i);
        console.log('是否微信环境=', isWechat)
        // 是否支付宝环境
        const isAlipay = userAgent.match(/AlipayClient/i);
        console.log('是否支付宝环境=', isAlipay)
        // 检查是否移动端
        const isMobile = /Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent);
        console.log('检查是否移动端=', isMobile)
        if (isWechat) {
          loadJs('https://res.wx.qq.com/open/js/jweixin-1.3.2.js').then(()=>{
            console.log('---wx.miniProgram=',wx.miniProgram);
            let ua = navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i)=="micromessenger") {
              //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
              wx.miniProgram.getEnv((res)=>{
                if (res.miniprogram) {
                  // alert("在小程序里");
                  this.backFlag = false
                } else {
                  // alert("不在小程序里");
                  this.backFlag = true
                }
              })
            }else{
              // alert('不在微信里');
              this.backFlag = true
            }
          })
        } else if (isAlipay) {
          // alert('支付宝小程序');
          this.backFlag = false
        } else if (/toutiaomicroapp/i.test(userAgent)){
            // 抖音 头条小程序
            this.backFlag = false
        } else {
          // alert('不在微信和支付宝');
          this.backFlag = true
        }
	},
	beforeCreate() {
		document.title = '抽奖';
	},
};
</script>

<style lang="scss">
.van-dialog__confirm, .van-dialog__confirm:active {
  color: #1989fa !important;
  background-color: white !important;
}
.van-dialog__message {
  font-weight: normal !important;
}
</style>

<style lang="scss" scoped>
/deep/.van-cell {
	width: 100%;
	height: 100%;
	background-color: #dcf6ff;
	line-height: 35px;
	padding-top: 0px;
	padding-bottom: 0px;
}
.home_container {
	width: 100%;
	height: 100%;
	padding-top: 20px;
	// background-image: url('../assets/image/bgc01.png');
	background-size: 100% 100%;
	.header_container {
		width: 100%;
		height: 50px;
		display: flex;
		.logo {
			flex: 3;
			padding-left: 15px;
			img {
				width: 100%;
			}
		}
		.centerBtn {
			flex: 2;
			padding-left: 10px;
		}
		.rightBtn {
			flex: 2;
			padding-left: 10px;
			.myGiftBtn {
				width: 90%;
				height: 100%;
				img {
					width: 100%;
				}
			}
		}
		.rightIcon {
			width: 30px;
			padding-left: 10px;
			padding-top: 5px;
			img {
				width: 50%;
			}
		}
	}
	.ruleTitle {
		width: 100%;
		min-height: 200px;
		.onlyLine {
			width: 100%;
			height: 10px;
			img {
				width: 60%;
				margin-bottom: 7px;
			}
		}
		.onlyLine02 {
			width: 100%;
			height: 20px;
			margin: 0 auto;
			img {
				width: 60%;
			}
		}
		.allOfOne {
			width: 100%;
			height: 200px;
			// background-image: url(../assets/image/allOfOne.png);
			// background-size: contain;
			// background-size: cover;
			background-size: 100% 100%;
			position: relative;
			.leftTopImg {
				width: 100px;
				height: 100px;
				position: absolute;
				top: 10px;
				left: 20px;
				img {
					width: 100%;
				}
			}
			.content_containerBox {
				width: 100%;
				height: 100%;
				padding: 10px 20px 35px;
				display: flex;
				.leftImgShow {
					flex: 2;
					padding: 20px;
					padding-left: 30px;
					box-sizing: border-box;
					display: flex;
					justify-content: center;
					align-items: center;
					img {
						width: 100%;
					}
				}
				.rightBtnTitle {
					flex: 3;
					padding: 30px 0px;
					padding-right: 30px;
					.btn {
						width: 95px;
						height: 30px;
						margin: 0 auto;
						margin-top: 5px;
						img {
							width: 100%;
						}
					}
				}
			}
		}
    .allOfOne_bg {
      // 旧背景路径
      background-image: url('../assets/image/allOfOne.png');
    }
    .allOfOne_bg_new {
      // 新背景路径
      background-image: url('../assets/image/gameImages/allOfOne.png');
    }
	}
}
.home_container_bg {
  // 旧背景路径
	background-image: url('../assets/image/bgc01.png');
}
.home_container_bg_new {
  // 新背景路径
  background-image: url('../assets/image/gameImages/bgc01.png');
}

.loadingBox {
	width: 100%;
	height: 80px;
	text-align: center;
	.content_loadingBox {
		width: 100px;
		height: 100%;
		margin: 0 auto;
		img {
			width: 100%;
		}
	}
}

.allNull {
	width: 100%;
	height: 90px;
	text-align: center;
	.content_loadingBox {
		width: 100px;
		height: 100%;
		margin: 0 auto;
		img {
			width: 50%;
		}
	}
}
.giftName_Box {
	width: 100%;
	height: 50px;
	font-size: 13px;
	overflow: hidden;
}
.gift_name_bottom_time_box {
	font-size: 13px;
}
.order_id_container {
	position: absolute;
	top: 126px;
	left: 37px;
	font-size: 12px;
}

.searchMore {
    text-align: center;
    //color: #0028F5;
}
</style>
